module.exports = __webpack_public_path__ + "img/image-style-12.f756ae7b.svg";